<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="50rem"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-if="list === true" @click="openDialog">
        <v-list-item-title>
          Vente
        </v-list-item-title>
      </v-list-item>
      <v-btn v-else-if="helper === true" dark block color="success" v-on="on">
        <v-icon small left>fa-plus</v-icon>
        Nouvelle Vente
      </v-btn>
      <v-btn v-else text dark color="success" v-on="on">
        <v-icon small left>fa-plus</v-icon>
        Nouvelle Vente
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" align="center" no-gutters>
          <v-btn
            v-if="getIsAdmin === true"
            :color="showConfig === true ? 'success' : ''"
            small
            icon
            text
            @click="showConfig = !showConfig"
          >
            <v-icon>fa-cog</v-icon>
          </v-btn>
          <v-spacer v-else></v-spacer>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <SalesInput
          v-bind.sync="data"
          :valid.sync="valid"
          :show-config="showConfig"
          @updateValue="calTotalAvTx"
          @updateOptionalValues="calTotalAvTx"
          @updateAvTx="calTaxes"
          @updateTx="calTotalApTx"
        ></SalesInput>
        <v-row no-gutters v-show="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters justify="end">
          <v-btn
            color="success"
            :disabled="!valid || loading"
            :block="$vuetify.breakpoint.xsOnly"
            @click="saveSale"
          >
            <v-icon small left>fa-save</v-icon>
            Enregistrer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { round10 } from "round10";
import { api } from "@/api";
import SalesInput from "./SalesInput";
import { mapGetters } from "vuex";
export default {
  name: "SalesAdder",
  components: {
    SalesInput
  },
  props: {
    list: {
      type: Boolean,
      default: false
    },
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getIsAdmin", "getSaleOptionalValues"])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      data: {
        date: null,
        value: 0,
        optional_value_1: null,
        optional_value_2: null,
        optional_value_3: null,
        optional_value_4: null,
        optional_value_5: null,
        value_before_tx: 0,
        tps: 0,
        tvq: 0,
        value_after_tx: 0
      },
      tpsRate: 0.05,
      tvqRate: 0.09975,
      valid: false,
      showConfig: false
    };
  },
  methods: {
    openDialog() {
      setTimeout(() => (this.dialog = true), 100);
    },
    async saveSale() {
      if (this.valid === true) {
        try {
          this.loading = true;
          const data = {
            ...this.data,
            store: this.getStoreId
          };
          await api.postSale(data);
          this.$store.dispatch("loadSales");
          this.$emit("update");
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    },
    calTotalAvTx() {
      let total = this.data.value;
      if (this.getSaleOptionalValues.length > 0) {
        this.getSaleOptionalValues.forEach(x => {
          let value = this.data[`optional_value_${x.value_number}`];
          if (value !== null) {
            if (x.is_subtraction === true) {
              total -= value * x.ratio;
            } else {
              total += value * x.ratio;
            }
          }
        });
      }
      this.data.value_before_tx = round10(total, -2);
      this.calTaxes();
    },
    calTaxes() {
      this.data.tps = round10(this.data.value * this.tpsRate, -2);
      this.data.tvq = round10(this.data.value * this.tvqRate, -2);
      this.calTotalApTx();
    },
    calTotalApTx() {
      this.data.value_after_tx = round10(
        this.data.value + this.data.tps + this.data.tvq,
        -2
      );
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.showConfig = false;
        this.data = {
          date: null,
          value: 0,
          optional_value_1: null,
          optional_value_2: null,
          optional_value_3: null,
          optional_value_4: null,
          optional_value_5: null,
          value_before_tx: 0,
          tps: 0,
          tvq: 0,
          value_after_tx: 0
        };
      }
    }
  }
};
</script>

<style></style>
